module.exports = __webpack_public_path__ + "static/img/svg3.967c5fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card/svg3.svg
// module id = ffcE
// module chunks = 1